/** @format */

// Alex 08Jan2024 Modified discount to 0.
const shadeTypeDefaults = {
  roller: {
    product: {
      Program_id: 1,
      Program: "Customized Roller Shade",
      Fabric_Type: "All",
      Default_Fabric_Type: "All",
      Price_Range: "$",
      Type: "Roller",
      Operation: "Chain",
      Colour_Family: "All",
      Price_Group: 0,
      Fabric_Code: "",
      Fabric: "",
      SG_Color: "",
      Min_Price: 0,
      Global_Discount: 0.35, // Global Discount for customized shades
      Discount: 0,
      Chain_Color: "",
      Valance: "Open Roll",
      Valance_Color: "-",
      Bottom_Bar: "Accubar 2.1",
      Bottom_Bar_Color: "White",
      Pick_A: "NULL",
      Pick_B: "Best Seller",
      Recommended: "#Blackout#$#Chain#The Dark Side",
      Recommended_Desc:
        '"Love This Fabric with 4 neutral colors selection and amazing price." - MIke',
      Recommended_photo: "3",
      Collection: "All",
      Min_Width: 18,
      Max_Width: 100,
      Min_Height: 36,
      Max_Height: 120,
      Description:
        "The All-Purpose Black Out Shade ticks all the boxes; clean look, simple, timeless and functional. This room darkening shade is ideal for bedrooms or anywhere where room darkening is desired. The textured weave provides some interest and the neutral colour pallet will co-ordinate with any decor. Reverse roll softens the look, no valance required.  Easy to install and operate and very well priced.",
      Valance_info:
        "Our open roll shades offer a pleasing minimalist design. Reverse roll conceals the tube and prevents the shade from contacting window cranks and other obstacles",
      BottomBar_info:
        "The Deluxe Flat aluminum bar offers a contemporary, clean look. The colour will coordinate with the fabric selected.",
      Control_info:
        "Roller shades are operated using a manual, simple, dependable clutch and chain system.  The stainless steel chain is concealed in a Safety Shield.  White Safety Shield is provided for all fabric except for black, where a black Safety Shield will be provided.",
      Thumbnail_Description: "Ideal where room darkening is desired",
      Design_Features:
        "100% Polyester, 4 colour selection, textured front and white fabric backing.",
      Inspiration:
        "The All Purpose Black out shade is great choice for price, function, athetic.  Excellent price for a blackout shade, great neutral colour pallet, looks amazing in the window.  Very durable, wipe clean fabric. iThe same fabric is offered in a privacy fabric if colour co-ordination is desired througout the house.",
      Collection_Description:
        "The Dark Side features Blackout shades.  All fabrics in the collection are opaque with white backing to completely block the sun and darken the room.  Enjoy better sleep by blocking  the sun light, moonlight, or street lights.  The simplicity of the shades and solid colour pallets gives you a clean canvas from which to accessorize your room.",
      shade_class: 0,
      Colors: ["White", "Light Grey", "Taupe", "Black"],
      Price: 0,
      Valance_Price: 0,
      Operation_Price: {
        Price: 0,
      },
      fabricColorRadio: "Cottonwood||Milk||Cottonwood-Milk-118",
      δ: 0.003,
      invalid: false,
      loading: true,
      position: "Right",
      spring: null,
      originalPrice: "0.00",
      L_Channel: "None",
      defaultBottomBar: "Plain Hem",
      Roll_Type: "Regular",
      Wrap_Type: "No",
      Hem_Wrap_Type: "No",
      charger: "No",
      remote: "No",
      connector: "No",
      chainColour: "None",
      OCS_Name: "Wisp",
      OCS_Colour: "Beige",
    },
    option: {
      widthWhole: "24",
      widthFraction: "",
      lengthWhole: "36",
      lengthFraction: "",
      customize: true,
      selectedColor: "Taffy",
      measure: "Tight",
      opacity: 1,
      OUR_PRICE: "0.00",
      RETAIL_PRICE: "0.00",
      quantity: 1,
    },
  },
  zebra: {
    product: {
      Program_id: 66,
      Program: "Customized Banded Shade",
      Fabric_Type: "All",
      Default_Fabric_Type: "All",
      Price_Range: "$",
      Type: "Banded",
      Operation: "Chain",
      Colour_Family: "All",
      Price_Group: 0,
      Fabric_Code: "",
      Fabric: "",
      SG_Color: "",
      Min_Price: 0,
      Global_Discount: 0.35, // Global Discount for customized shades
      Discount: 0,
      Chain_Color: "280",
      Valance: "",
      Valance_Color: "",
      Bottom_Bar: "Interlude 2.0",
      Bottom_Bar_Color: "White",
      Pick_A: "NULL",
      Pick_B: "NULL",
      Recommended: "Banded",
      Recommended_Desc: "",
      Recommended_photo: "",
      Collection: "All",
      Min_Width: 24,
      Max_Width: 90,
      Min_Height: 36,
      Max_Height: 100,
      Description:
        "The Toronto Banded Shade combines translucent fabric with tranparent vanes for total control over privacy and light. These vanes cascade around the system, allowing you to determine the perfect light and atmosphere for any room.  Chain operated, housed in a fabric Wrapped Curved Cassette.",
      Valance_info:
        "This shades includes a Curved Cassette wrapped in the same fabric as the shade to create a stunning window treatment.",
      BottomBar_info:
        "Tear drop shaped aluminum bottom bar; colour is set to match the valance.",
      Control_info:
        "Banded shades are operated using a manual, simple, dependable clutch and chain system.  The stainless steel chain is concealed in a Safety Shield.  White Safety Shield is provided for all fabric except for black, where a black Safety Shield will be provided.",
      Thumbnail_Description: "Toronto Privacy Banded Shade with Valance",
      Design_Features: "100 % polyester material,  3 neutral colours",
      Inspiration:
        "Toronto Privacy Banded is a great entry level banded shade providing complete sunlight control.  The ribbing of the solid vanes and the horizontal lines of the transpartent vane provide a layering effect to add interest to even all white rooms.  The wrpped curved cassette finishes the look and allows for easy installation.",
      Collection_Description: "NULL",
      shade_class: 10,
      Colors: ["Angel", "White", "Grey"],
      Price: 0,
      Valance_Price: 0,
      Operation_Price: {
        Price: 0,
      },
      fabricColorRadio: "Gossamer||Angel||Gossamer-Angel-110",
      δ: 0.003,
      invalid: false,
      loading: true,
      position: "Right",
      spring: null,
      originalPrice: "0.00",
      L_Channel: "None",
      defaultBottomBar: "Interlude 2.0",
      Roll_Type: "Regular",
      Wrap_Type: "No",
      Hem_Wrap_Type: "No",
      charger: "No",
      remote: "No",
      connector: "No",
      chainColour: "None",
      OCS_Name: "Lace",
      OCS_Colour: "Grey",
    },
    option: {
      widthWhole: "24",
      widthFraction: "",
      lengthWhole: "36",
      customize: true,
      lengthFraction: "",
      selectedColor: "Angel",
      measure: "Tight",
      opacity: 1,
      OUR_PRICE: "0.00",
      RETAIL_PRICE: "0.00",
      quantity: 1,
    },
  },
  sheer: {
    product: {
      Program_id: 86,
      Program: "Customized Sheer Shade",
      Fabric_Type: "All",
      Price_Range: "$$$",
      Type: "Sheer",
      Default_Fabric_Type: "All",
      Operation: "Chain",
      Colour_Family: "All",
      Price_Group: 0,
      Fabric_Code: "",
      Fabric: "",
      SG_Color: "",
      Min_Price: 292,
      Global_Discount: 0.35, // Global Discount for customized shades
      Discount: 0,
      Chain_Color: "501",
      Valance: "",
      Valance_Color: "",
      Bottom_Bar: "Illusion",
      Bottom_Bar_Color: "White",
      Pick_A: "NULL",
      Pick_B: "NULL",
      Recommended: "Sheer",
      Recommended_Desc: "",
      Recommended_photo: "",
      Collection: "All",
      Min_Width: 24,
      Max_Width: 90,
      Min_Height: 36,
      Max_Height: 120,
      Description:
        "Elegance Sheer Shade combines transparent fabric with translucent vanes for total control over privacy and light. These vanes tilt open and closed allowing you to determine the perfect light and atmosphere for any room. Sheer shades create an elegant, sophisticated environment. Fabric wrapped curved cassette completes the look.",
      Valance_info:
        "This shades includes a Curved Cassette wrapped in the same fabric as the shade to create a stunning window treatment.",
      BottomBar_info:
        "Exclusive to the Sheer Shade, this aluminum bottom bar co-ordinates in colour to the fabric chosen.",
      Control_info:
        "Sheer Shades are operated using a manual, simple, dependable clutch and chain system.  The stainless steel chain is concealed in a Safety Shield.  White Safety Shield is provided for all fabric except for black, where a black Safety Shield will be provided.",
      Thumbnail_Description: "Privacy Elegance Sheer Shade",
      Design_Features: "100% polyester in 3 colours",
      Inspiration:
        "With their front and back sheer fabric, sheer shades diffuse light and provide UV protection, and allow outward visibility. Tilting the vanes that float between the two sheer panels lets you control the amount of light entering your room. ",
      Collection_Description: "NULL",
      shade_class: 15,
      Colors: ["Soft White", "White", "Grey"],
      Price: 0,
      Valance_Price: 0,
      Operation_Price: {
        Price: 0,
      },
      fabricColorRadio: "Natural||Dusk||Natural Opaque-Dusk-110",
      δ: 0.003,
      invalid: false,
      loading: true,
      position: "Right",
      spring: null,
      originalPrice: "0.00",
      L_Channel: "None",
      defaultBottomBar: "Illusion",
      Roll_Type: "Regular",
      Wrap_Type: "No",
      Hem_Wrap_Type: "No",
      charger: "No",
      remote: "No",
      connector: "No",
      chainColour: "None",
      OCS_Name: "Richmond",
      OCS_Colour: "Grey",
    },
    option: {
      widthWhole: "24",
      widthFraction: "",
      lengthWhole: "36",
      customize: true,
      lengthFraction: "",
      selectedColor: "Dusk",
      measure: "Tight",
      opacity: 1,
      OUR_PRICE: "0.00",
      RETAIL_PRICE: "0.00",
      quantity: 1,
    },
  },
  simply_cellular: {
    product: {
      Program_id: 1,
      Program: "Customized Simply Cellular Shade",
      Fabric_Type: "All",
      Price_Range: "$",
      Type: "Simply Cellular",
      Colour_Family: "All",
      Price_Group: 0,
      Fabric_Code: "",
      Fabric: "",
      SG_Color: "Beige",
      Min_Price: 0,
      Global_Discount: 0.35, // Global Discount for customized shades
      Discount: 0,
      Chain_Color: "",
      Default_Fabric_Type: "All",
      Price: 0,
      fabricColorRadio: "Cottonwood||Milk||Cottonwood-Milk-118",
      invalid: false,
      loading: true,
      spring: null,
      originalPrice: "0.00",
      L_Channel: "None",
      OCS_Name: "Wisp",
      OCS_Colour: "Beige",
    },
    option: {
      widthWhole: "24",
      widthFraction: "",
      lengthWhole: "36",
      lengthFraction: "",
      customize: true,
      selectedColor: "Taffy",
      measure: "Tight",
      opacity: 1,
      OUR_PRICE: "0.00",
      RETAIL_PRICE: "0.00",
      quantity: 1,
    },
  },
};

export { shadeTypeDefaults };
